import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import StatsGridOne from "../components/StatsGridOne";
import DualChartDashboard from "../components/DualChartDashboard";
import RevenuePrediction from "../components/RevenuePrediction";
import FeatureUsageAnalytics from "../components/FeatureUsageAnalytics";
import ProductHealthDashboard from "../components/ProductHealthDashboard";
import CountriesComponent from "../components/CountriesComponent";
import StatsGridThree from "../components/StatsGridThree";
import StatsGridTwo from "../components/StatsGridTwo";

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };

  return (
    <div>
      <Sidebar onSidebarStateChange={handleSidebarStateChange} />
      <Navbar sidebarOpen={sidebarOpen} />
      <StatsGridOne sidebarOpen={sidebarOpen} />
      {/* <StatsGridTwo /> */}
      <StatsGridThree sidebarOpen={sidebarOpen} />
      <DualChartDashboard sidebarOpen={sidebarOpen} />
      {/* <RevenuePrediction /> */}
      <CountriesComponent sidebarOpen={sidebarOpen} />
      <FeatureUsageAnalytics sidebarOpen={sidebarOpen} />
      <ProductHealthDashboard sidebarOpen={sidebarOpen} />
    </div>
  );
};

export default Dashboard;
